import React from 'react';
import { HiTag } from 'react-icons/hi';
import TagPill from '../../ui/TagPill';
import styles from './UserTagsDisplay.module.css';

interface UserTagsDisplayProps {
  tags: string[];
  maxVisible?: number;
  onClick?: () => void;
  className?: string;
  emptyText?: string;
}

const UserTagsDisplay: React.FC<UserTagsDisplayProps> = ({
  tags,
  maxVisible = 1,
  onClick,
  className = '',
  emptyText = 'No tags',
}) => {
  const visibleTags = tags.slice(0, maxVisible);
  const remainingCount = tags.length - maxVisible;

  if (tags.length === 0) {
    return (
      <span
        className={`${styles.container} ${onClick ? styles.clickable : ''} ${className}`}
        onClick={onClick}
        role={onClick ? 'button' : undefined}
        tabIndex={onClick ? 0 : undefined}
      >
        <span className={styles.emptyPill}>
          {/* @ts-ignore - react-icons compatibility with React 19 */}
          <HiTag size={12} className={styles.emptyIcon} />
          <span>{emptyText}</span>
        </span>
      </span>
    );
  }

  return (
    <span
      className={`${styles.container} ${onClick ? styles.clickable : ''} ${className}`}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      {visibleTags.map((tag) => (
        <TagPill key={tag} tag={tag} size="small" />
      ))}
      {remainingCount > 0 && (
        <span className={styles.moreCount}>+{remainingCount}</span>
      )}
    </span>
  );
};

export default UserTagsDisplay;
